import React, { useEffect } from "react";
import moment from "moment";
import * as jwtDecode from "jwt-decode";
import { useTracked } from "./state";
import { identityService } from "./services/vault";
import { loadAuthMode } from "./context/vault";
// import { setMobileIsAppLockedState } from "./utils/helpers/LocalStorage";
// import { isPlatform } from "@ionic/react";
import { ShowToastErrorMessage } from "./utils/helpers/ToastMessage";
import { useHistory } from "react-router";
import { userRemovePushToken } from "./api/user";

const SessionChecker: React.FC = () => {
  const history = useHistory();
  const [state, dispatch] = useTracked();

  useEffect(() => {
    if (state.mqm) {
      // let interval: any = "";
      const token = localStorage["token"]
        ? JSON.parse(localStorage["token"])
        : undefined;
      if (token) {
        const { exp } = jwtDecode(token);
        checkTokenValidity(exp);
        // interval = setInterval(() => {
        //   checkTokenValidity(exp);
        // }, 5000);
      }
      //  else {
      //   if (interval) {
      //     clearInterval(interval);
      //   }
      // }
    }

    // return () => {
    //   if (interval) {
    //     clearInterval(interval);
    //   }
    // };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.mqm]);

  const checkTokenValidity = (exp: any) => {
    const now = moment().unix();
    const isValid = exp > now;
    // console.log("session check validity", isValid);

    if (!isValid) {
      // if (isPlatform("cordova")) {
      //   handleLock();
      // } else {
      //   handleLogout();
      // }

      handleLogout();

      ShowToastErrorMessage(
        "Session expired, please relogin to your account.",
        {
          autoClose: 8000,
        }
      );
    }
  };

  const updateVaultAuth = async () => {
    const { authMode, biometricType, hasSession, biometricsSupported } =
      await loadAuthMode();

    dispatch({
      type: "setVaultAuth",
      authMode,
      biometricType,
      hasSession,
      biometricsSupported,
    });
  };

  const handleLogout = async () => {
    userRemovePushToken(state.identity.toLowerCase(), state.pushToken);
    await identityService.logout();
    await updateVaultAuth();
    if (state.mqm) {
      await state.mqm.pubnub.publish({
        channel: state.identity.toLowerCase(),
        meta: {
          type: "logout",
        },
        message: { appId: process.env.REACT_APP_APP_ID },
      });
    }

    history.replace("/", { direction: "none" });
  };

  // const handleLock = async () => {
  //   // if (
  //   //   state.biometricType &&
  //   //   state.biometricType !== "none" &&
  //   //   state.hasSession
  //   // ) {
  //   await identityService.lockOut();
  //   setMobileIsAppLockedState(true);
  //   dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
  //   history.push("/", { direction: "none" });
  //   // }
  // };

  return null;
};

export default SessionChecker;
